import { render, staticRenderFns } from "./student-info.vue?vue&type=template&id=5523d41c&scoped=true&"
import script from "./student-info.vue?vue&type=script&lang=js&"
export * from "./student-info.vue?vue&type=script&lang=js&"
import style0 from "./student-info.vue?vue&type=style&index=0&id=5523d41c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5523d41c",
  null
  
)

export default component.exports